module.exports = __webpack_public_path__ + "static/cl-spumanterosado-prod-7cec9c908599908eae688b56112a5964.jpg";